import en_US from './en_US'
import zh_CN from './zh_CN'
import vi_VN from './vi_VN'
import th_TH from './th_TH'
import hi_IN from './HI_IN'
export default {
    en_US,
    zh_CN,
    vi_VN,
    th_TH,
    hi_IN
}


// WEBPACK FOOTER //
// ./src/pages/build902/i18n/langs/index.js